<script>
    import BaseDialog from './BaseDialog.svelte';

    let {
        dialogRef = $bindable(),
        onKeydown = null
    } = $props();

    function focus(x) { x.focus(); }
</script>

<BaseDialog bind:dialogRef={dialogRef} size="sm:max-w-2xl" title="Text Input Help" {onKeydown} showClose={false}>
    {#snippet children({ dialog })}
        <!-- svelte-ignore a11y_no_noninteractive_tabindex -->
        <!-- svelte-ignore a11y_no_static_element_interactions -->
        <div use:focus tabindex="0" onkeydown={onKeydown} class="p-6 outline-none">
            <div class="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-6">
                <p class="text-sm text-amber-900">
                    Press <kbd class="px-2 py-1 bg-white rounded text-amber-900 font-mono text-xs shadow-sm">h</kbd> to return to the main menu
                </p>
            </div>

            <div class="mb-4">
                <p class="text-gray-700 mb-4">When the text input box is focused, the following bindings work:</p>
            </div>

            <div class="space-y-2">
                <div class="flex items-start p-3 bg-gray-50 rounded-lg">
                    <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-gray-900 font-mono text-sm mr-4 shadow-sm min-w-[120px]">enter</kbd>
                    <span class="text-gray-700">Jump to next line and play</span>
                </div>
                <div class="flex items-start p-3 bg-gray-50 rounded-lg">
                    <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-gray-900 font-mono text-sm mr-4 shadow-sm min-w-[120px]">ctrl-space</kbd>
                    <span class="text-gray-700">Play current span</span>
                </div>
                <div class="flex items-start p-3 bg-gray-50 rounded-lg">
                    <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-gray-900 font-mono text-sm mr-4 shadow-sm min-w-[120px]">ctrl-d</kbd>
                    <span class="text-gray-700">Delete current line</span>
                </div>
                <div class="flex items-start p-3 bg-gray-50 rounded-lg">
                    <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-gray-900 font-mono text-sm mr-4 shadow-sm min-w-[120px]">ctrl-m</kbd>
                    <span class="text-gray-700">Merge active segment with following segment</span>
                </div>
                <div class="flex items-start p-3 bg-gray-50 rounded-lg">
                    <kbd class="px-2 py-1 bg-white border border-gray-300 rounded text-gray-900 font-mono text-sm mr-4 shadow-sm min-w-[120px]">ctrl-,</kbd>
                    <span class="text-gray-700">Split active segment at cursor</span>
                </div>
            </div>
        </div>
    {/snippet}
</BaseDialog>
